import { render, staticRenderFns } from "./SectionList.vue?vue&type=template&id=ad361756&scoped=true"
import script from "./SectionList.vue?vue&type=script&lang=js"
export * from "./SectionList.vue?vue&type=script&lang=js"
import style0 from "./SectionList.vue?vue&type=style&index=0&id=ad361756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad361756",
  null
  
)

export default component.exports